var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrictred(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.772461,
    width: 11.4551,
    height: 12,
    rx: 2,
    fill: "#E6374C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49805 8.54883C6.89888 8.54883 7.22363 8.87358 7.22363 9.27441C7.22347 9.67511 6.89878 10 6.49805 10C6.0974 9.9999 5.77262 9.67505 5.77246 9.27441C5.77246 8.87364 6.0973 8.54893 6.49805 8.54883ZM6.5 2C6.69288 2.00003 6.87826 2.06571 7.01465 2.18262C7.1508 2.29942 7.2274 2.45794 7.22754 2.62305V6.98828C7.22746 7.15342 7.15079 7.31187 7.01465 7.42871C6.87826 7.54562 6.69288 7.6113 6.5 7.61133C6.30708 7.61133 6.12177 7.54564 5.98535 7.42871C5.84912 7.31186 5.77254 7.15347 5.77246 6.98828V2.62305C5.7726 2.45789 5.84912 2.29943 5.98535 2.18262C6.12177 2.06569 6.30708 2 6.5 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictred);
export default __webpack_public_path__ + "static/media/restrictred.c0fe2b190f364ae08d4696f5a71b3faf.svg";
export { ForwardRef as ReactComponent };